import React from 'react'
import '../index.css';

const OurProcess = () => {
    return (
        <section className='ourProcess'>
            <h1 data-translate="OurProcessTitle" className='fadeOnScroll'>Our Development Process</h1>
            {/* <p>We follow a clear step-by-step workflow to ensure every project is efficient, transparent, and aligned
                with your goals.</p> */}
            <br />

            <div className='ourProcessCard fadeOnScroll'>
                <i style={{ color: "var(--primary-color)" }} className="fas fa-lightbulb"> </i>
                <p data-translate="OurProcess1"><strong>Discovery & Planning</strong> - We discuss your idea, audience, goals, required features,
                    preferred art style, and platform. We provide a rough estimate and propose solutions.</p>
            </div>

            <div className='ourProcessCard fadeOnScroll'>
                <i style={{ color: "var(--primary-color)" }} className="fas fa-cube"></i>
                <p data-translate="OurProcess2"><strong>Concept & Prototype</strong> - We create a basic playable or visual prototype to confirm
                    core mechanics, UX flow, or educational/game objectives before full production begins.</p>
            </div>
            <div className='ourProcessCard fadeOnScroll'>
                <i style={{ color: "var(--primary-color)" }} className="fas fa-cogs"></i>
                <p data-translate="OurProcess3"><strong>Full Development</strong> - We build the complete experience: gameplay systems, levels, UI,
                    art, sound, and logic using the Godot engine.</p>
            </div>
            <div className='ourProcessCard fadeOnScroll'>
                <i style={{ color: "var(--primary-color)" }} className="fas fa-vial"></i>
                <p data-translate="OurProcess4"><strong>Testing & Feedback</strong> - You test the build, provide feedback, and we refine the
                    experience. We ensure performance, polish, and usability.</p>
            </div>
            <div className='ourProcessCard fadeOnScroll'>
                <i style={{ color: "var(--primary-color)" }} className="fas fa-rocket"></i>
                <p data-translate="OurProcess5"><strong>Delivery & Post-Launch Support</strong> - Final delivery of the game/app, plus optional
                    updates, maintenance, or future expansion if needed.</p>
            </div>
        </section>
    )
}

export default OurProcess